/**
 * Created by dafre on 5/11/2017.
 */

import { Component, Input } from '@angular/core';
import { Injectable }     from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class GetJson{

  constructor(private http:Http) {
  }

  public getAll(jsonFile : string ): Promise<Object> {
    return this.http.get(jsonFile)
      .toPromise()
      .then((response) => {
        return response.json();
      }).catch((err) => {
        console.log(err);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/getJson.ts